import * as React from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import { Typography, TextField, Input, Tooltip } from "@material-ui/core";

interface Props {
  classes: any;
  count: number;
  onChangePage: (event, page) => void;
  page: number;
  rowsPerPage: number;
  theme: any;
}

class TablePaginationActions extends React.Component<Props> {
  state = {
    page: this.props.page
  };
  componentWillReceiveProps(next: Props) {
    this.setState({ page: next.page });
  }
  handleFirstPageButtonClick = event => {
    this.props.onChangePage(event, 0);
  };

  handleBackButtonClick = event => {
    this.props.onChangePage(event, this.props.page - 1);
  };

  handleNextButtonClick = event => {
    this.props.onChangePage(event, this.props.page + 1);
  };

  handleLastPageButtonClick = event => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1)
    );
  };

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props;

    return (
      <div
        className={classes.root}
        style={{ flexDirection: "row", alignItems: "center" }}
      >
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <Tooltip title="Press Enter to go">
          <Input
            value={this.state.page}
            disableUnderline
            type="number"
            style={{
              marginLeft: 12,
              minWidth: 20,
              width: "100%",
              marginTop: 4,
              maxWidth: (this.state.page.toString().length + 1) * 12
            }}
            onChange={e => {
              this.setState({ page: e.target.value });
            }}
            onKeyDownCapture={e => {
              if (e.keyCode === 13) {
                this.props.onChangePage(event, this.state.page);
              }
            }}
          />
        </Tooltip>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }
}
const actionsStyles = theme => ({
  root: {
    flexShrink: 0,
    display: "flex",
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5
  }
});
export const TablePaginationActionsWrapped = withStyles(actionsStyles, {
  withTheme: true
})(TablePaginationActions);



// WEBPACK FOOTER //
// ./src/components/tablePaginationActions.tsx